// extracted by mini-css-extract-plugin
export default {"checkboxGroup":"Notification_checkboxGroup__4xVdf","radioGroup":"Notification_radioGroup__sLqll"};